export const encodeURIComponentIfNotEncoded = (possiblyEncodedURIComponent: string): string => {
  const decodedURIComponent = decodeURIComponent(possiblyEncodedURIComponent)
  const uriIsAlreadyEncoded = possiblyEncodedURIComponent !== decodedURIComponent
  return uriIsAlreadyEncoded
    ? possiblyEncodedURIComponent
    : encodeURIComponent(possiblyEncodedURIComponent)
}
